/* eslint-disable no-param-reassign */
import produce from 'immer';
import { GET_METRICS, SET_DATE_RANGE } from 'src/actions/analyticsActions';

const initialState = {
  metrics: [],
  prevPeriod: [],
  dateRange: {
    value: 'this_week',
    text: 'This week'
  }
};

const analyticsReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_METRICS: {
      const { metrics, prevPeriod } = action.payload;

      return produce(state, (draft) => {
        draft.metrics = metrics;
        draft.prevPeriod = prevPeriod;
      });
    }
    case SET_DATE_RANGE: {
      const { dateRange } = action.payload;

      return produce(state, (draft) => {
        draft.dateRange = dateRange;
      });
    }

    default: {
      return state;
    }
  }
};

export default analyticsReducer;
